import * as React from 'react';
import styled, { keyframes } from 'styled-components';

/**
 * Props for an input error message
 *
 * @member error message specifying an error
 * @member warning message specifying a warning
 * @member valid message specifying a validation
 */
export interface FormMessageFeedbackProps {
    error: string;
    warning: string;
    valid?: string;
}

const upDownAnnimatioon = keyframes`
    0% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
    100% { transform: translateY(0); }`;

const StyledMessage = styled.div`
    display: flex;
    div {
        font-size: 12px;
        text-align: left;
        align-self: flex-start;
        margin-left: 2px;
        animation: ${upDownAnnimatioon} 0.2s 2 normal forwards;
    }
`;

export const StyledError = styled.div`
    color: ${(props) => props.theme.color.orange};
`;
export const StyledWarning = styled.div`
    color: ${(props) => props.theme.color.orange};
`;

export const StyledValid = styled.div`
    color: ${(props) => props.theme.color.green};
`;

const FormMessageFeedback = (props: FormMessageFeedbackProps) => (
    <StyledMessage>
        {props.error ? <StyledError>{props.error}</StyledError> : null}
        {props.warning ? <StyledWarning>{props.warning}</StyledWarning> : null}
        {props.valid ? <StyledValid>{props.valid}</StyledValid> : null}
    </StyledMessage>
);

export default FormMessageFeedback;
